import { ViewId } from "@remi/types/view";

import { hasCapability, type User } from "../base";
import { escalationHub } from "./escalationHub";

export const view = {
  read: (user: User, view: ViewId) => {
    if (view === ViewId["travelers-cleanup"]) {
      return escalationHub.read(user);
    }
    if (view === ViewId["review-financial-adjustments"]) {
      return hasCapability(user, "view.read.reviewFinancialAdjustments");
    }
    if (view === ViewId.finance) {
      return hasCapability(user, "view.read.finance");
    }
    if (view === ViewId["my-assignments"] || view === ViewId["org-assignments"]) {
      return hasCapability(user, "view.read.insurance");
    }
    if (view === ViewId["1099-estimating"]) {
      return hasCapability(user, "view.read.estimating");
    }
    if (view === ViewId["contractor-dash"]) {
      // The dash page's cross-organization plate read requires this same capability.
      return hasCapability(user, "contractorProfile.read.all");
    }
    if (hasCapability(user, "view.read.default")) {
      return true;
    }
    return (
      hasCapability(user, "view.read.contractorTasks") &&
      (view === ViewId["my-tasks"] || view === ViewId["project-milestones"])
    );
  },
};
